import { FC } from 'react';
import classnames from 'classnames';

import { SPALink } from '@hh.ru/redux-spa-middleware';
import { IconColor, ArrowSquareScaleSmall } from 'bloko/blocks/icon';

import Badge from 'src/components/Badge';
import { MenuType } from 'src/models/menu';
import { useSelector } from 'src/modules/useSelector';
import sendAnalytics from 'src/utils/analytics';

import { isActiveItem, MenuItemWithUrl } from 'src/components/Menu/utils';

import styles from 'src/components/Menu/menu.less';

const MenuLink: FC<MenuItemWithUrl> = ({ name, level, activators, text, type, url, badge }) => {
    const pageName = useSelector(({ request }) => request.pageName);
    const isExternal = type === MenuType.ExternalLink;

    const isActive = isActiveItem(name, pageName, activators);

    const onClickMenuLink = () => {
        sendAnalytics.menuLinkClick(name);
    };

    const commonProps: Record<string, string> = {
        className: classnames(styles.menuLink, {
            [styles.menuLinkLevel2]: level,
            [styles.menuLinkExternal]: isExternal,
            [styles.menuLinkActive]: isActive,
        }),
    };

    if (isExternal) {
        commonProps.target = '_blank';
    }

    const renderContent = () => (
        <>
            {text}
            {isExternal && (
                <span className={styles.menuLinkExternalIcon}>
                    <ArrowSquareScaleSmall initial={IconColor.Gray80} />
                </span>
            )}
            {badge && <Badge kind={badge} />}
        </>
    );

    if (isActive) {
        return <span {...commonProps}>{renderContent()}</span>;
    }

    return (
        <SPALink {...commonProps} to={url} onClick={onClickMenuLink} data-qa={`menu-link_${name}`}>
            {renderContent()}
        </SPALink>
    );
};

export default MenuLink;
